import { useTheme } from '@/hooks/useTheme';

const navLinks = [
  { label: 'Home', href: '#hero' },
  { label: 'Services', href: '#services' },
  { label: 'Industries', href: '#industries' },
  { label: 'Case Studies', href: '#results' },
  { label: 'Contact', href: '#cta' },
];

export default function FooterSection() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <footer className="transition-colors duration-500" style={{ background: isDark ? '#111827' : '#ffffff' }}>
      <div className={`border-t transition-colors duration-500 ${isDark ? 'border-white/6' : 'border-black/6'}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-12">
            {/* Brand */}
            <div className="flex flex-col items-start gap-4">
              <a href="#hero" className="cursor-pointer">
                <img
                  src="https://public.readdy.ai/ai/img_res/a6aaf78b-ae52-4def-a2c6-79fec2f6b030.png"
                  alt="PuleAI"
                  className="object-contain"
                  style={{ width: '120px', height: '120px' }}
                />
              </a>
              <p className={`text-sm leading-relaxed max-w-xs ${isDark ? 'text-gray-500' : 'text-gray-600'}`}>
                Where Intelligent Systems Take Control.
              </p>
              <div className="flex items-center gap-2">
                <span className={`w-1.5 h-1.5 rounded-full ${isDark ? 'bg-cyan-400/60' : 'bg-blue-500/60'}`}></span>
                <span className={`text-xs tracking-wide ${isDark ? 'text-gray-600' : 'text-gray-500'}`}>Operational Intelligence Firm</span>
              </div>
            </div>

            {/* Nav links */}
            <nav className="flex flex-wrap gap-x-10 gap-y-3">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  rel="nofollow"
                  className={`text-sm transition-colors tracking-wide cursor-pointer whitespace-nowrap ${
                    isDark ? 'text-gray-500 hover:text-gray-300' : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Bottom bar */}
          <div className={`mt-12 pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-3 transition-colors duration-500 ${
            isDark ? 'border-white/5' : 'border-black/5'
          }`}>
            <p className={`text-xs tracking-wide ${isDark ? 'text-gray-700' : 'text-gray-400'}`}>
              &copy; {new Date().getFullYear()} PuleAI. All rights reserved.
            </p>
            <p className={`text-xs tracking-wide ${isDark ? 'text-gray-700' : 'text-gray-400'}`}>
              Designed for businesses that cannot afford inefficiency.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}